/**
 * Remote speakers sharing one frame carry the same `data.speakerGroup`. Players show whoever is talking;
 * the Control preview shows the first member, so one frame is never painted with stacked videos.
 */
export function showFirstOfSpeakerGroups<T extends { visible?: boolean; data?: Record<string, string> }>(
  layers: T[],
): T[] {
  const seen = new Set<string>();
  return layers.map((layer) => {
    const group = layer.data?.speakerGroup;
    if (!group || layer.visible === false) {
      return layer;
    }
    if (seen.has(group)) {
      return { ...layer, visible: false };
    }
    seen.add(group);
    return layer;
  });
}
